import { typeCreatorV2 } from 'redux/utils/common';

export const SET_PRODUCT_IMAGES: string = typeCreatorV2(
  'ProductImagesReducer',
  'SetProductImages'
);

export const INSERT_PRODUCT_IMAGES: string = typeCreatorV2(
  'ProductImagesReducer',
  'InsertProductImages'
);

export const SET_SELECTED_IMAGES: string = typeCreatorV2(
  'ProductImagesReducer',
  'SetSelectedImages'
);

export const REARRANGE_IMAGES: string = typeCreatorV2(
  'ProductImagesReducer',
  'RearrangeImages'
);

export const UPDATE_IMAGE_VISIBILITY: string = typeCreatorV2(
  'ProductImagesReducer',
  'UpdateImageVisibility'
);

export const UPDATE_LIST_IMAGE_VISIBILITY: string = typeCreatorV2(
  'ProductImagesReducer',
  'UpdateListImageVisibility'
);

export const DELETE_IMAGE: string = typeCreatorV2(
  'ProductImagesReducer',
  'DeleteImage'
);
export const DELETE_LIST_IMAGE: string = typeCreatorV2(
  'ProductImagesReducer',
  'DeleteListImage'
);

export const SET_IMAGE_INFO: string = typeCreatorV2(
  'ProductImagesReducer',
  'SetImageInfo'
);

export const UPDATE_IMAGE_INFO: string = typeCreatorV2(
  'ProductImagesReducer',
  'UpdateImageInfo'
);

export const SET_CAPTION_IAMGE: string = typeCreatorV2(
  'ProductImagesReducer',
  'SetCaptionIamge'
);

export const RESET_CAPTION_IAMGE: string = typeCreatorV2(
  'ProductImagesReducer',
  'ResetCaptionIamge'
);

export const UPDATE_CAPTION_IAMGE: string = typeCreatorV2(
  'ProductImagesReducer',
  'UpdateCaptionIamge'
);

export const RESET_SELECTED_IMAGE: string = typeCreatorV2(
  'ProductImagesReducer',
  'ResetSelectedImage'
);
